import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { getPlatform } from "@/lib/platform";

const STYLE: CSSProperties = {
  background: "var(--d-ember)",
  color: "#fff",
  textAlign: "center",
  padding: "8px 16px",
  fontFamily: "var(--font-mono)",
  fontSize: 11,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
};

function resolveEnv(): "production" | "dev" {
  // iOS Capacitor serves from capacitor://localhost — hostname is useless
  // there; the bundle's build mode is the truth. Everywhere else the
  // hostname decides, defaulting to production (the scary banner must
  // err toward caution).
  if (getPlatform().name === "ios") return import.meta.env.PROD ? "production" : "dev";
  const h = window.location.hostname;
  if (h === "dev.psyna.app" ||
    h === "dev.theduetto.com" || h === "localhost" || h === "127.0.0.1") return "dev";
  return "production";
}

export function EnvBanner(): JSX.Element | null {
  const { t } = useTranslation("admin");
  const env = resolveEnv();
  if (env !== "production") return null;
  return (
    <div data-testid="env-banner" style={STYLE} role="status">
      {t("env_banner.production")}
    </div>
  );
}
